import React, { useContext } from "react";

import LoggedInLayout from "../layout";
import NewLayout from "../layout-new/NewLayout";
import { LayoutPreferenceContext } from "../context/LayoutPreference/LayoutPreferenceContext";

// Escolhe o shell (Classico ou Novo) conforme a preferencia do usuario -
// projeto 2026-10-21 (ver PROMPT.md em D:\voicechat\novo layout). Os
// dois recebem exatamente os mesmos `children` (as rotas), trocar de
// layout nao muda a rota nem perde o ticket aberto.
const LayoutSwitcher = ({ children }) => {
	const { layout } = useContext(LayoutPreferenceContext);

	if (layout === "new") {
		return <NewLayout>{children}</NewLayout>;
	}
	return <LoggedInLayout>{children}</LoggedInLayout>;
};

export default LayoutSwitcher;
